import React from "react";
import AddvertiseItem from "../Dashboard/Seller/AddvertiseItem/AddvertiseItem";
import Section1 from "./Section1/Section1";
import Section2 from "./Section2/Section2";
import Section3 from "./Section3/Section3";
import Section4 from "./Section4/Section4";

const Home = () => {
  return (
    <div>
      <Section1></Section1>
      <Section2></Section2>
      <AddvertiseItem></AddvertiseItem>
      <Section4></Section4>
      <Section3></Section3>
    </div>
  );
};

export default Home;
